(function () {
    'use strict';

    angular
        .module(app.modules.common.name)
        .factory('focus', focusFactory);
    
    focusFactory.$inject = ['$document', '$timeout'];
    function focusFactory($document, $timeout) {
        return function focus(selector) {
            // TOTO: allow selector to be a string or an element.
            $timeout(function () {
                var element = $document[0].querySelector(selector);
                if (element)
                    element.focus();
            }, 0, false);
        };
    }
})();